// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3lDsz","buttons":"SendReceipts_buttons__1mnWm","email":"SendReceipts_email__stxpQ","bookApptTitle":"SendReceipts_bookApptTitle__1a9yT"};